var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScience(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 360 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#8258f3;opacity:0.1;}.cls-3{fill:#f6f7fa;}.cls-4{fill:#ccc;}.cls-5{fill:#f3f2f7;}.cls-6{mix-blend-mode:multiply;opacity:0.25;}.cls-7{fill:#fff;}.cls-8{fill:#31e000;}.cls-9{fill:url(#Degradado_sin_nombre_4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4",
    x1: 221.85,
    y1: 150.74,
    x2: 221.85,
    y2: 57.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7187e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b198f8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M208.6,78c15.4.3,20.1-7.2,44.5-4.5,19.4,2.1,28.3-6.8,29.7-12.9,1.7-7.7-4.8-20.2-35.9-14.9-35.3,6-49.9-19.3-68.4,4.2C170.8,59.5,173.6,77.3,208.6,78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M82.9,138.9a73.1,73.1,0,0,1-12.4-.8c-3.8-.7-5.8-1.6-5.8-2.8h0l7.1-54.2L68.3,70.8A2.7,2.7,0,0,1,70,67.2l1-.2,23.6.2a3,3,0,0,1,2.8,2.9,2.9,2.9,0,0,1-.2.9L93.9,81.1l7.1,54.2C101,138.2,89.6,138.9,82.9,138.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 69.4,
    y: 131.3,
    width: 11.5,
    height: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 69.4,
    y: 127.4,
    width: 11.5,
    height: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 69.4,
    y: 123.5,
    width: 11.5,
    height: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 69.4,
    y: 119.6,
    width: 11.5,
    height: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 69.4,
    y: 115.7,
    width: 11.5,
    height: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M186.6,138.9a73.1,73.1,0,0,1-12.4-.8c-3.8-.7-5.8-1.6-5.8-2.8h0l7.1-54.2L172,70.8a2.7,2.7,0,0,1,1.7-3.6l1-.2,23.6.2a2.9,2.9,0,0,1,2.8,2.9c0,.3-.1.6-.1.9l-3.4,10.1,7.1,54.2C204.7,138.2,193.3,138.9,186.6,138.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 173.1,
    y: 131.3,
    width: 11.5,
    height: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 173.1,
    y: 127.4,
    width: 11.5,
    height: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 173.1,
    y: 123.5,
    width: 11.5,
    height: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 173.1,
    y: 119.6,
    width: 11.5,
    height: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 173.1,
    y: 115.7,
    width: 11.5,
    height: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M138,138.9a73.1,73.1,0,0,1-12.4-.8c-3.9-.7-5.8-1.6-5.8-2.8h0l7.1-54.2-3.6-10.3a2.8,2.8,0,0,1,1.8-3.6l1-.2,23.6.2a3,3,0,0,1,2.8,2.9,2.9,2.9,0,0,1-.2.9L149,81.1l7.1,54.2C156.1,138.2,144.7,138.9,138,138.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 124.5,
    y: 131.3,
    width: 11.5,
    height: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 124.5,
    y: 127.4,
    width: 11.5,
    height: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 124.5,
    y: 123.5,
    width: 11.5,
    height: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 124.5,
    y: 119.6,
    width: 11.5,
    height: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 124.5,
    y: 115.7,
    width: 11.5,
    height: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M214.6,143h-22V106h22a4.5,4.5,0,0,0,4.5-4.5,4.6,4.6,0,0,0-4.5-4.6H61a4.6,4.6,0,0,0-4.5,4.6A4.5,4.5,0,0,0,61,106H79.8v37H61a4.5,4.5,0,0,0,0,9H214.6a4.5,4.5,0,0,0,4.5-4.5,4.4,4.4,0,0,0-4.5-4.5ZM88.9,143V106h94.6v37Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-6",
    width: 112,
    height: 184,
    transform: "translate(166 -2)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHAAAAC4CAYAAAA7W2iSAAAACXBIWXMAAAsSAAALEgHS3X78AAAT+klEQVR4Xu2da5IbNxKEi6OR7N3TOWLvsYfxPRzhy+2uJc0M94dYmmQy6wE0mg9ZGYEA2GyiK+tDockhLR+Ox6P91OPqqTrhp+5bz9UJ19K///XnoTrnXvT7H7/dzbZ1uOYW+kiQZnVtuLsDDKD9iCAvEnkNmLsAFNBGHz+COHHh4z1BLgVI4NS4ev6RhIk7Ui+P7QFyGUCAl/XVOax7ABsliAEdm8eWgtwMMKi6AzR+zA1f57oHcCy1RTIo1dS5yyBuAijgMbAnGKvHGch7ghhtjaq9BeMLmCsgrvocGEF5gnYQ4wikz4m6JlBVbTiOoL1BO9q3mBVEM7Pjv//152ErxOkKpHueqjKH9QHGUetCvIUyeG9Je6XHqiI3V+IUwAIetg+iPdFYVaRBz+NricF5ryru1d6BvYrGcJdB3LKFcoIjcM+nxmOGeG+V2K08BPUC/Yu9+3i1czlEOz0/Bc9sogKD6svAfQx6BBlBNOhRewBVieDKi+C9QPsa9FylF/fGmSqcrUCuFIbooLx9oh4hOkgF0WwfWF2prVPB+wrt2cy+2LsPJZ/3TRwb0ixAlKpAB/gJ2i/Q+3MRxFtvo9H2mcH7As19KOF8Z9vnzLvSIYDB5z6uQNw6Hdiv1CNEr0bcTjvb6N6Ktk/eNhHcZ/vmRVUfLwK1SIfgmQ0CPIkTq9684Nbp4P5x6r15Rfq5eP/kxeG6Bsio+hAg3u8cXASPt15+J3pWhaOaAehS1cdvXhggNq9ErEJPAG5Bt6jCI/WecLV1frb32wHuHlyxOH6y9yo80+g22gaYfK+HENU9EAH+89Qc4q/2fo/ke+G9VSACwPueL0CP21/HnwVf4Bz2N12FbYAkvjhvo/gu1CuNIf7TLrdS9WbGoL+msArxzQvf+xyex+jn4jbr705f7N0XV6H3QyBnAaLUNtqFiFWI90Jepa5rgFQVyADx3sfw+P6oFibfJ69WgZhQrsIKorofYhXym5l7BsiV5+cwOPUOm3eWTZ5GAUZSICOICBJbdh80uzS6yThJrX58A4MAfTtU8PCeiF6ye98mzQJUF1YViR8NECTDvMf7YPQGRr1ZebHziuN31Co3vLP4Yhh6JzoLEKUqo6pIbwxUfZxggHuCrN6B+h+o/flXy6uN4Zktjn8WIBtVwoAZZgY0W72RZpMSxa7egeJicngIrbtVRtv19+Pd6jMbB+gTq4Qdix4VwUSguIr9NdjvIVWB+KcvO40jWCj0fwZopUYBojAoNJv1HZgItXsfnIUaVYP3R3uP72j5rqCAvdFj1TZpC0BXFNhb0iqYDFQBnIUWCePhBDs8Bqc8Mzj2rOae1pM1RfsyXlyZUH//48cM1MX3DgSKYFXVzrZoXlVpZvli5T+hRYt3CcQtFaggcrDq74HKoDLl4iTuWYWoo+n52ataqLMQh0G2KzBQtQpfkjYK0uwc4kp4aoFEVTfiU0E8Qr9ZMxUYVZ73XG34t8ERky6uhD0q0K93sPNr4/MRvJGFGlXg92uOfIQwG6xAcR+MKtANIjzVlMmqCl2r4JnlW6XyGIFjX+gt2kI3aQhgIjSYrczMIJtcanSDMnidHYYhHu3S27THrQCjCmR4VQUqkNOmFiiqPG8ID72wt2hxSnCj26fZPEC8sDKrqjCCyGZLozuKr9Pxle0uqgKXLs5hgMl9kFdpZrKqvmj7XGacxHNWvqId5sW0N16UyyAOAwzEZnmlZtsMNn9tVIWozeYLRRCrKsQ+20LPrjOzfZrNfYxwHaGfMcurFY3ynFPmJqWu7b4yL1x12S3BaDytqQpsfpzomr2q4URqbrUoR7xlt4UlXqYABnKjI4ZfqSl4y8w2xIslWpiRJ/bCnpYvyq0AlWGEyIAy02w4MrfZdCGcW3mqfHUX5PfrzN7/zDYAhIvyxdGwMq0qjw3zHHtDU1IJV7vKSNUt9zANkMQBstlOUwlj08sTEIivGS1KbgxRvXYpyFUAXRGACp6CyfPupWhutSi7II805nlwvk1aCZAD9DGDjMxljee9tjjpyhd6i+Jf7mEFQBVYBSQDdW9SACoPu4NzrQCIUoEeg97H/Fgdv7VUjNFzDG9XrQb4U1fWNQF2voDd6ycTW9X9FUD0I6jddA2AbOaQtHtUtaii+PHYbt5WA+SA2XwFr3puD43OW/nAmP383bQCIAeMx/H5kcbaNQmBqhi7DedbrhUAXQfRc+Mfy/KPaW+ShIYiL/wD4MoD+9mslQBRFUQGFxm/lVTC2YPy1IG4VKsBRoFX4NRqVvMZjfdUFIOKWXlT4NScm7QaIEqZVjCzFbvZ4ISyhDMgFX9Wicu1EmAEoFqx9wISr8MQI1/dCtzNyyqAHNQMxAONozmvpVFwFcRdNA2w+JebcNwxrgzvbn5AI16u6mkaoFAHnDKvzmGTyvCyJJCihGOcHLP6hw0UPNSS+LcC5OAY4hONqxWr5ltidFIZyMpT28+W/ynYVoBKymzHcLRycd69pObma7OfyJM6R4FcopUAOdDI9JNdbjldeHx8b3HSM0/KD3sy6jf7WQWQk80mK8MK3hKDk8r8VF74nF29rADIKwrHDFL9S0bK/C5mG2IPfDyDGO0qUVuiKYDJTTczOgIuWgjXVpT8CCL7yRblEj9TAIWipEeGGCgm5dbQlCJP3Dr/3BaPN2kLQJVgBaAynUE06FGbjRfKEt/xVC3OC81+lNgC0BUZRJNsONpOO/CurcgXeoo+yGe+lnhbAdBMB6eMZA1f5/O4lpgtpK7BnkZ9Kfh8nU0wVwF0caDKbPczIBveZHSDIojcsirMPG3SCoAqsAjcCLxbC2NgXxFE1dif0XiTtgLkIHiVdo3ia3ieZWabUonmFnmb+aP2Jg0DLD4Deo9GR9puRhdoBGIEUs2zScMAhTCQaLVmK1W9BudmbTbdlIorAxd5xNcoaJv8zAKMAlEGO2YrkLdWBTGrOgVP+pv5LDgL0MUBRQbVyoxWJ5sbNrVB6locC3rsLFLOB4PcpK0AzfTKqiBG5m8JL1Pkkf11/kDB8Pj4kFYAdHGQHXiRQQVyyuBGqRjcV8cfn7MJltJWgFHiK2MZuHvTVoiRzyV+twDkiyuIbDD7Smk3kxPi60ZxdTweaKzmntYQwL/ZTwmVut6u9rXSEEChDjhlVp3D4JSpaaOTyhLfBZkt2AuNfpSYAagM4fEnGmctS9C9iWNFrwpYZ6Fu9joDUEkZUwYiiNHK3GRuUuqanHAFr/KoGmoK5laAUWDKWPebCJzb+2FjOyiCWPk80FhBnPa3BSAnm01FBjN4CuStpRYVxp15zPwajac0C1AFwABwRY78Iu1elHlDjwri1b5WagP8G/2UsNIIxN2/VmoDFIqSrgJWQNH8EjM7KYoPY88WaeYXNeV7FGB0YdUqQ5kpZWbK4GLNeGS/lc+hz4KjAF0YQGSKDXb+Uo9z31LVAsp8d3yy32nPswDNdBAKXGdFehycpHtTBq7yyWMFbhjmFoAuZYiNdT8DYjMa31K8sCrPWRUqzwb9kGYBqgAicCPw7lkKIvvJmvJsNB7WDEC+WLQSq48QGchNphaK44jirHyi36UeWwAHv0ZiON7UVyzK1KNoNcgp7y2AQgyOgWSBR0Z4btSUuYWKEp55nflrzLDPEYB8UYaYGVJm1HzDBm6gDGQGdMh397PgCEClCFxlJFqROO+tpWLgGLve1TkK5LBmAXIAkZlHhZeJkz7iHc9T8FQ+Us0A5GRz8Gykey9QINtGrqDMdxceg9zscRQgrxQcM8hH/RqJxV75eAYx+gwctWGVAH9+jXShKPkRRPadLd5h3yVAoSjpUaAMFM0+CjSlyDu3XX9i2AWoEqwAVGYyiAY9asjQjsoS3/FeLeILdT5KdAG6osAxeDbS+XoF534ERf7R+1V+YjgK0ExfVAWYNXydz+MaNrGjVCzsfdS/gs/XacOcAejiAJSJkW8iMOi2gRspgsht958YjgJUF4zAjcB7FGGs7D+CqBrnwWjc1ghAnpxXX9cAvobnmTJxBalEc4ty0P1DxpRSgH/jf5GiqxGIu/zEMAUohBeIVmG2AtVrcG7WkJkrSMWfgYtyga9R0Nq+OwCjC6jAOyYqkI+iCmJWdQqezEP1WbAD0MUXigJXKy5adRz0PYJUMXHMmIvOYua8Mci2RgCa6RVTQYxMPQK8TFEuOA+dP2QwPD4eahSgiy/egRcFrkCWgd9QKlb338kDn9OGpTQCMEp8FXAG7lG1FWKUj+G8dAHypAoiB559pbQk+CuL44vi7+TiQGM1d0shwMGfEnLAClgG7pHVzcEuXyuFAIU64JQJdQ6DU8G2DNxAWeK7ILOFfaHso0QFUAWKx59onLXM+KOKPWFOFLDOgh7KSQVQSQWsAosgRiuuHfQNpGLjhCt4VS5UQ5UwRwBGF1QBd7+JwLm9v2eQrAhilY8DjRXEVh66ADnZHGwUeAZPgXwUqcWH/rJcZHkxGpfqAFQTMwBcaSO/SHs0ZTnAXCiIu3ytJAH+/CnhsEYgLv1aSQIUipKuAlFA0dRwkHeoyAd6zBZzlhdUmZ8MYDShalWgWbAqyDLwO9JMLjgvVT7CXTED6MKJo2A58M5f4HHuR1C10LL8dPLBeWnlpgPQTE+uwHVWml+TzT+qMnBVPniswKUwuwBdKlAOuPsZEJvR+BHEC7DKTVaFKjcGfagOQDVxBG4E3o8gBZF9Z03lxmicqgLIk0QrrPoIkYFsB3sn4ngjP1U+MC/TubgAOPg1EsPxpr46UcH+aFoNsszRBUAhBsdAsoCiAHluVBn0nShKeJaTmb/GpPmIAPJkDDELVAWp5nsUUB1lIDOgQ/lRu2MEUCkCVwUYrTSc91GkYmUv3RypcxTIVB2APHEU5I8OLxMnfSRHKq9GPeftuyqA/CIOigPs7vEK5CPCVB7QcwdeBLOlDKBaAdyqACOIjy70UUGs8pTlt8zVGcDm10idoCp4Q0E+gKLkq5x0fm7Z1hnAQFHSsyDxueh1P6qq/ETHqiZVATyIHsFwQBxcK4gH0jF5jj1GILrgpHiXVACjCSqIPFYBZRCP0GeJupUwpizGEXDZIk9Bup6T5xiYgsHBZfDMLk1jIjjY6Pi1pWLu6iB6BTbLWeo/A6gUQcTnsY+kVjA+zqDfSqoC0Qc/9mMqJyqPLD7mj8/yUQGMQFSrhA1m7c3qe3GlasFEGl0cClbW8DUsLoKoAv0cOU8FsKvM2Nup4fjN3gN9gsdHOw92FkxXXYB4Hnp9o4aeI6A8T6bS/yxAXmEcOBt7M7NX6HGVOTSvwqyylcLV2VTntQogen2l9kbjCLTReFijAHlFRaC8vVD7YOfwPtg7QKxKs0t4HZiu6NyRREUVo/wrv3hMwcQFjw1VxlsBVCsvAhhB+3pq/hcIl79OvYM10Ueqnq9UJekoekw+LtivonE+uFIVxDbICqCLg+bVx7C+mtmXU3s+NYfkr322/D94VAC7sLZWYLVwMQcM8EvQGGhUlRFEqQxgFHhUcQjus5l9snNIPtermX209y3Vnz9Ab3YJ0lU9HlW12jmhuP3xIkb/f53a51NjmAgyg8gczqQA+kleLdmqQ3gITsHz1306ne/PV1W4pRJHhQmKFrDnwBfjm+k8/GVm/zs1hBlVI0NsaWYLVdumB/3x1NSWiec/Q3syXYUMbwTg7BbKABliVH14//Mqc4D/PbUIJENUCyaMu9pCq+pDeA6Et0xfqW4QITPACiL2PN6iqPK8Z3hYfWoxO8C/7B0gQswAMsQz/f7Hb2fHzgD+/sdvR/GdIBqIAubtECsPb+54b2TgWRVGW6l6PCpOEoPjBczwuAK/2vt9D7fR/9g3iFEV8psaXkhS1Raqqu+DvQf8wc7BYeUh7C9m9ot9g4cVqF6vKtFsfBsdFVchJlBtnbwbcQU6RK86r0CHiG9s/PUIjyFKkBFAP9kriSG+2LfkfrXzavHXRvAcYFaB0VZqoufxjBgc9xHAV2peSV5Vn+2yErF3iFkFhuBch+Px8vnTNurNk+iV4ol3GL9A+xV6H3869R/tffvkCpwFuBWeS4HzvgvQK5A/TuG70uzjRXk/5PufWb2Fmr2bebNvCXs99V9Px7HyjnZu6It9g8bvULH6FECGh82gd82C5IQwON593J+CiNsovyNlmNirClTXl6rehfJjhsjw0NRXO7/nRfCiNzEKoEHP4y1CrxFEvv9FVegQ8Z6IMPFYBe+7VPWZBQDp3SgbeqPT8Xm89320bwE+ixbByyrQkn6rjkmfAcwgckWqscPjbbN9D6y20KOdVxnD8+MI79neA1TQnu0dWvXu854q0D0yTKwehKhgvtBzCF6BO5rF1WeWAIQq5BerCnRT/hHDA/wQNIcV3fe2bJ8V1CgZHYgKYBcmP36DHuF535J8F4qCrVRVBFcPQslgqYZzZvAYUAWsEifgKPoIYgSTATFUPp/nNu+z6jNrADSTEH2sKqdqBzGO4JkYs1YDxGNHMcZEVyCjphYCX6uEZ9YEaHYB0XtuCig+V1UaN6Oxayu0SJyMCKBqEZgK2DQ8swGAZiFE76vWAaagISwFbitMlQA8xgBxnIHsNp67Dc9sEKDZxU+7I5A4zo5lr3MxoK3AKnFCGOYIUH5Ove57PwLONQzQFYDEsaqi6FjWu/YGx4pAdvoSFo9n4JltAOgSXz9FMKNj1UJQ2gtmlgyZeOsBil47Dc61GSCqgMmPK1h7QZqVSlQFVT7eCg21FCAq+fdmlEaPX1tRktrHV0JD7QYQVf0fuOx+QI0qTd5e0FBXAajUgPpQugYspZsB7OrWoG8Fpqu7B/hTuZ6qE37qvvV/f/CgkAEXzdYAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M221.9,164a152.5,152.5,0,0,1-25.4-1.8c-8.3-1.4-12.3-3.4-12.3-6.2h0L198.7,45.4l-7.2-20.8a6.4,6.4,0,0,1,6.1-8.6l48.2.5a6.5,6.5,0,0,1,6.4,6.5,6.5,6.5,0,0,1-.4,2L245,45.4l14.5,110.5h0c0,3-4.5,5.1-13.9,6.5A170.4,170.4,0,0,1,221.9,164Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 216.2,
    cy: 53.3,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 226.7,
    cy: 50.4,
    r: 4.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 218.8,
    cy: 40.4,
    r: 5.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M242.5,150.7H201.2a7.5,7.5,0,0,1-7.6-7.5,4.1,4.1,0,0,1,.1-1.1l12.1-81.8a2.4,2.4,0,0,1,2.7-2l1.2.5c7.3,5.9,15.4,5.8,23.8-.4a2.7,2.7,0,0,1,2.3-.2,2.3,2.3,0,0,1,1.5,1.8L250,142a7.7,7.7,0,0,1-6.3,8.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 202.4,
    y: 141.2,
    width: 23.5,
    height: 1.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 202.4,
    y: 133.2,
    width: 23.5,
    height: 1.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 202.4,
    y: 125.3,
    width: 23.5,
    height: 1.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 202.4,
    y: 117.4,
    width: 23.5,
    height: 1.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 202.4,
    y: 109.4,
    width: 23.5,
    height: 1.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M241.4,88.6a17.4,17.4,0,0,1-14,5.1,19.4,19.4,0,0,1-8.1-2.7c-2.7-1.4-5.3-3.1-8.2-3.9s-5.6-.8-7.8.9a1.2,1.2,0,0,1-1.3.1l.3-1.7c2.4-1.8,5.4-2,8.3-1.4,5.9,1.1,10.4,6,16.5,6.7A15.8,15.8,0,0,0,241,86.1h0Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScience);
export default __webpack_public_path__ + "static/media/science.2c4970f4cd94378d4226d43e04914555.svg";
export { ForwardRef as ReactComponent };